import { useRouter } from 'next/router'
import { ChangeEvent, useCallback, useEffect, useState } from 'react'

import debounce from 'lodash.debounce'
import { useIntl } from 'react-intl'

import TextInput from 'app/components/base/TextInput'

const SearchSupport = () => {
  const { formatMessage } = useIntl()
  const { push, query, isReady } = useRouter()
  const keyword = (query?.keyword ?? '') as string
  const [searchValue, setSearchValue] = useState<string>('')

  useEffect(() => {
    if (!isReady) return

    const needToSetKeyword = !!keyword && !searchValue

    if (needToSetKeyword) setSearchValue(keyword)
  }, [isReady])

  const pushHandler = (keyword: string) => {
    const pathname = !!keyword ? '/help-centre/search' : '/help-centre'

    push({
      pathname,
      ...(!!keyword && { query: { keyword } })
    })
  }

  const debouncePushHandler = useCallback(debounce(pushHandler, 300), [])

  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const keyword = event.target.value ?? ''

    setSearchValue(keyword)

    debouncePushHandler(keyword)
  }

  return (
    <TextInput
      label={formatMessage({ defaultMessage: 'Search Support' })}
      onChange={changeHandler}
      value={searchValue}
      autoFocus={!!keyword}
      InputProps={{ style: { height: 56 } }}
      sx={{
        width: { xs: '100%', sm: 470 },
        backgroundColor: 'background.dark',
        '& label': {
          lineHeight: '28px'
        }
      }}
    />
  )
}

export default SearchSupport
